import Styled from "styled-components";

export const LinkImage = Styled.a`
  height: 180px;
  background: url(${(props) => props.img}) no-repeat;
  text-align: center;
  display: block;
  width: 100%;
  background-position: center;
  background-size: contain;
  border-radius: 10px 10px 0 0;
`;

export const Bold = Styled.b`
`;

export const ContainerGrid = Styled.div`
  display: grid;
  grid-auto-rows: 20px;
  margin-bottom: 10px;
`;

export const Button = Styled.button`
  display: inline-block;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: var(--button-border-radius);
  color: ${(props) => props.theme.whitelabel?.theme?.button_secondary_color};
  background-color: ${(props) => props.theme.whitelabel?.theme?.button_primary_color};
  width: 100%;
  height: 40px;
`;
export const Down = Styled.div`
  position: absolute;
  bottom: 0;
  left:0;
  right:0;
  margin-left:auto;
  margin-right:auto;
`;

export const Container = Styled.div`
  .card-product {
    justify-content: center;
    text-align: center;
    display: flex;
    flex-flow: row wrap;
    height: 430px;
    border: 2px solid #FAFBFF;
    border-radius: 8px;
  }
  .card-body-product {
    padding: 0;
  }

  .product-favorite-star {
    position: absolute;
    width:20px;
    height:20px; 
    top: 5px;
    right: 5px;
    z-index: 1;
  }


  .title-product {
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
    color: var(--primary-color);;
    line-height: 21px;
    font-size: 14px;
  }
`;
